export const formatTrendPercentage = (trend: number | null): string => {
  if (trend === null) {
    return "-";
  }
  const sign = trend > 0 ? "+" : "";
  return `${sign}${trend}%`;
};
